import { Injectable } from '@angular/core';
import { ContentfulService } from 'src/app/shared/services/contentful.service';
import { Entry } from 'contentful';
import { ContentFulModel } from 'src/app/shared/models/contentfulmodel';
import { BehaviorSubject } from 'rxjs';
import { PageId } from 'src/app/shared/utilities/pageids.enum';
import { MetaService } from 'src/app/shared/services/meta.service';

@Injectable({
  providedIn: 'root',
})
export class vPayService {
  constructor(
    private contentful: ContentfulService,
    private meta: MetaService
  ) {}

  vPayData: any;

  private vPayHeroSubject$ = new BehaviorSubject<any>(null);
  public vPayHero$ = this.vPayHeroSubject$.asObservable();
  private vPayCustomerStatsSubject$ = new BehaviorSubject<any>(null);
  public vPayCustomerStats$ = this.vPayCustomerStatsSubject$.asObservable();
  private vPayFeaturePanel1Subject$ = new BehaviorSubject<any>(null);
  public vPayFeaturePanel1$ = this.vPayFeaturePanel1Subject$.asObservable();
  private vPayFeaturePanel2Subject$ = new BehaviorSubject<any>(null);
  public vPayFeaturePanel2$ = this.vPayFeaturePanel2Subject$.asObservable();
  private vPayVideoPanelSubject$ = new BehaviorSubject<any>(null);
  public vPayVideoPanel$ = this.vPayVideoPanelSubject$.asObservable();
  private vPayCustomerStoryPanelSubject$ = new BehaviorSubject<any>(null);
  public vPayCustomerStoryPanel$ =
    this.vPayCustomerStoryPanelSubject$.asObservable();
  private vPayDiscoverDifferencePanelSubject$ = new BehaviorSubject<any>(null);
  public vPayDiscoverDifferencePanel$ =
    this.vPayDiscoverDifferencePanelSubject$.asObservable();
  private vPayPricingPanelSubject$ = new BehaviorSubject<any>(null);
  public vPayPricingPanel$ = this.vPayPricingPanelSubject$.asObservable();
  private vPayWhitePaperPanelSubject$ = new BehaviorSubject<any>(null);
  public vPayWhitePaperPanel$ = this.vPayWhitePaperPanelSubject$.asObservable();
  private getStartedSubject$ = new BehaviorSubject<any>(null);
  public getStarted$ = this.getStartedSubject$.asObservable();
  private borderLessSubject$ = new BehaviorSubject<any>(null);
  public borderLess$ = this.borderLessSubject$.asObservable();

  getvPayPageData() {
    this.contentful
      .getEntries(
        Object.assign({
          content_type: PageId.solutionsPage,
          include: 10,
        })
      )
      .then(res => {
        let mod = res.items as Entry<any>[];
        this.vPayData = mod.filter(x => x?.fields['id'] == PageId.vPayPage);

        const heroData = this.vPayData[0].fields.psHeroPanel.fields;
        if (heroData) {
          this.vPayHeroSubject$.next(heroData);
        }
        const featurePanel1 = this.vPayData[0]?.fields?.psFeatures[0]?.fields;
        if (featurePanel1) {
          this.vPayFeaturePanel1Subject$.next(featurePanel1);
        }
        const featurePanel2 =
          this.vPayData[0]?.fields?.psOtherProductsPanel?.fields;
        if (featurePanel2) {
          this.vPayFeaturePanel2Subject$.next(featurePanel2);
        }
        const videoPanel = this.vPayData[0]?.fields?.psProductVideo?.fields;
        if (videoPanel) {
          this.vPayVideoPanelSubject$.next(videoPanel);
        }
        const customerStoryPanel =
          this.vPayData[0]?.fields?.psCustomerStories?.fields;
        if (customerStoryPanel) {
          this.vPayCustomerStoryPanelSubject$.next(customerStoryPanel);
        }
        const discoverDifferencePanel =
          this.vPayData[0]?.fields?.psTableFeaturesComparison?.fields;
        if (discoverDifferencePanel) {
          this.vPayDiscoverDifferencePanelSubject$.next(
            discoverDifferencePanel
          );
        }
        const pricingPanel = this.vPayData[0]?.fields?.psPricingPanel?.fields;
        if (pricingPanel) {
          this.vPayPricingPanelSubject$.next(pricingPanel);
        }
        const whitePaperPanel =
          this.vPayData[0]?.fields?.psWhitepaperForm?.fields;
        if (whitePaperPanel) {
          this.vPayWhitePaperPanelSubject$.next(whitePaperPanel);
        }
        const getStarted = this.vPayData[0].fields.psGetStartedPanel.fields;
        if (getStarted) {
          this.getStartedSubject$.next(getStarted);
        }
        const borderLess =
          this.vPayData[0].fields.psMobileAppGetStartedPanel.fields;
        if (borderLess) {
          this.borderLessSubject$.next(borderLess);
        }
      });
  }
}
